export default "__VITE_ASSET__CrxmY52j__"